import axios from "axios";
import React, { Component } from "react";
import SupplierForm from "./SupplierForm";
import FeatherIcon from "feather-icons-react";
import EstablishmentprofileData from "../../../components/rh/establishmentprofiles/EstablishmentprofileData";
import Listprint from "../../Listprint";

import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
class Supplier extends Component {
  state = {
    isModal: false,
    isModalProfile: false,
    loading: true,
    loadError: "",
    user: "",
    userestablishprofile: "",
    formData: "",
    search: "",
    suppliers: [],
    columns: [
      { label: "#", field: "number", sort: "asc", width: 50 },
      { label: "Fournisseur", field: "supplier", sort: "asc", width: 220 },
      { label: "Contact", field: "contact", sort: "asc", width: 160 },
      { label: "Responsable", field: "responsible", sort: "asc", width: 220 },
      { label: "Téléphone", field: "tel", sort: "asc", width: 140 },
      {
        label: "",
        field: "action",
        sort: "disabled",
        width: 120,
        printable: false,
      },
    ],
  };

  componentDidMount() {
    this.getSuppliers();
  }

  getSuppliers = async () => {
    this.setState({ loading: true, loadError: "" });

    try {
      const response = await axios.get("suppliers");

      this.setState({
        suppliers: Array.isArray(response.data) ? response.data : [],
      });
    } catch (error) {
      this.setState({
        loadError: "Impossible de charger la liste des fournisseurs.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  showModal = (supplier = null) => {
    this.setState(
      (state) => ({
        isModal: !state.isModal,
        formData: state.isModal ? "" : supplier,
      }),
      () => {
        if (!this.state.isModal) this.getSuppliers();
      }
    );
  };

  delete = async (supplier) => {
    const name = supplier?.name || "ce fournisseur";

    if (!window.confirm(`Supprimer définitivement « ${name} » ?`)) return;

    try {
      const response = await axios.delete(`suppliers/${supplier.id}`);

      toast.success(response?.data?.msg || "Le fournisseur a été supprimé.");
      this.getSuppliers();
    } catch (error) {
      toast.error(error.response?.data?.msg || "La suppression a échoué.");
    }
  };

  showModalProfile = (userestablishprofile = null, user = null) => {
    this.setState(
      (state) => ({
        isModalProfile: !state.isModalProfile,
        userestablishprofile,
        user,
      }),
      () => {
        if (!this.state.isModalProfile) this.getSuppliers();
      }
    );
  };

  can = (permission) => {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]").some(
        (item) => permission === item.permission
      );
    } catch (error) {
      return false;
    }
  };

  getResponsibleName = (supplier) => {
    const user = supplier?.user || {};

    return [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  };

  getInitials = (supplier) => {
    const name = this.getResponsibleName(supplier) || supplier?.name || "FR";

    return name
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join("")
      .toUpperCase();
  };

  matches = (supplier, query) => {
    if (!query) return true;

    const user = supplier?.user || {};

    return [
      supplier?.name,
      supplier?.contact,
      this.getResponsibleName(supplier),
      user?.tel,
      user?.email,
    ]
      .filter(Boolean)
      .some((value) =>
        String(value).toLocaleLowerCase("fr").includes(query)
      );
  };

  rows = (suppliers) =>
    suppliers.map((supplier, index) => {
      const user = supplier?.user || {};
      const responsibleName =
        this.getResponsibleName(supplier) || "Responsable non renseigné";

      return {
        number: index + 1,

        supplier: (
          <span className="staff-table-identity">
            <b>{supplier.name || "Fournisseur sans nom"}</b>
            <small>{supplier.contact || "Contact non renseigné"}</small>
          </span>
        ),

        contact: supplier.contact || <em>Non renseigné</em>,

        responsible: (
          <span className="staff-table-person">
            <span className="staff-table-avatar">
              {user.avatar ? (
                <img src={user.avatar} alt="" />
              ) : (
                <i>{this.getInitials(supplier)}</i>
              )}
            </span>

            <span>
              <b>{responsibleName}</b>
              <small>{user.email || "E-mail absent"}</small>
            </span>
          </span>
        ),

        tel: user.tel ? (
          <a href={`tel:${user.tel}`} className="staff-table-contact">
            <FeatherIcon icon="phone" size={13} />
            {user.tel}
          </a>
        ) : (
          <em>Téléphone absent</em>
        ),

        action: (
          <span className="staff-table-actions">
            {this.can("Modifier fournisseur") && (
              <button
                type="button"
                onClick={() => this.showModal(supplier)}
                title="Modifier ce fournisseur"
              >
                <FeatherIcon icon="edit-3" size={15} />
              </button>
            )}

            {this.can("Supprimer fournisseur") && (
              <button
                type="button"
                className="danger"
                onClick={() => this.delete(supplier)}
                title="Supprimer ce fournisseur"
              >
                <FeatherIcon icon="trash-2" size={15} />
              </button>
            )}
          </span>
        ),
      };
    });

  render() {
    const query = this.state.search.trim().toLocaleLowerCase("fr");

    const suppliers = [...this.state.suppliers]
      .sort((a, b) => String(a.name || "").localeCompare(b.name || "", "fr"))
      .filter((supplier) => this.matches(supplier, query));

    const withResponsible = this.state.suppliers.filter(
      (supplier) => supplier.user
    ).length;

    const withContact = this.state.suppliers.filter(
      (supplier) => supplier.contact || supplier.user?.tel || supplier.user?.email
    ).length;
    const toComplete = this.state.suppliers.length - withResponsible;

    return (
      <main className="container staff-page">
        <Helmet>
          <title>{process.env.REACT_APP_NAME} | Fournisseurs</title>
        </Helmet>

        <header className="staff-header">
          <div>
            <span>
              <FeatherIcon icon="truck" size={14} />
              Approvisionnement
            </span>
            <h1>Liste des fournisseurs</h1>
            <p>
              Gérez les fournisseurs, leurs contacts et les responsables associés.
            </p>
          </div>

          <nav>
            <Link to="/manuel#suppliers" className="btn btn-light">
              <FeatherIcon icon="book-open" size={17} /> Doc
            </Link>
            {this.can("Ajouter fournisseur") && (
              <button type="button" onClick={() => this.showModal(null)}>
                <FeatherIcon icon="plus" size={18} />
                Nouveau fournisseur
              </button>
            )}
          </nav>
        </header>

        <section className="staff-stats" aria-label="Résumé">
          <article>
            <i>
              <FeatherIcon icon="truck" />
            </i>
            <b>
              {this.state.suppliers.length}
              <small>Fournisseurs</small>
            </b>
          </article>

          <article>
            <i>
              <FeatherIcon icon="user-check" />
            </i>
            <b>
              {withResponsible}
              <small>Avec responsable</small>
            </b>
          </article>

          <article>
            <i>
              <FeatherIcon icon="phone-call" />
            </i>
            <b>
              {withContact}
              <small>Contacts disponibles</small>
            </b>
          </article>
          <article>
            <i>
              <FeatherIcon icon="user-plus" />
            </i>
            <b>
              {toComplete}
              <small>Responsables à compléter</small>
            </b>
          </article>
        </section>

        <section className="staff-panel">
          <div className="staff-toolbar">
            <div>
              <span>Répertoire</span>
              <h2>Fournisseurs enregistrés</h2>
            </div>

            <label>
              <FeatherIcon icon="search" size={16} />
              <input
                type="search"
                value={this.state.search}
                onChange={(e) => this.setState({ search: e.target.value })}
                placeholder="Nom, contact, responsable…"
              />

              {this.state.search && (
                <button
                  type="button"
                  onClick={() => this.setState({ search: "" })}
                >
                  <FeatherIcon icon="x" size={14} />
                </button>
              )}
            </label>
          </div>

          {this.state.loading ? (
            <div className="staff-state">
              <FeatherIcon className="user-search-spin" icon="loader" />
            </div>
          ) : this.state.loadError ? (
            <div className="staff-state error">
              <FeatherIcon icon="alert-circle" />
              <h3>Liste indisponible</h3>
              <p>{this.state.loadError}</p>
              <button type="button" onClick={this.getSuppliers}>
                Réessayer
              </button>
            </div>
          ) : suppliers.length ? (
            <div className="staff-list">
              <Listprint
                columns={this.state.columns}
                rows={this.rows(suppliers)}
                title="Liste des fournisseurs"
              />
            </div>
          ) : (
            <div className="staff-state">
              <FeatherIcon icon={query ? "search" : "truck"} />
              <h3>{query ? "Aucun résultat" : "Aucun fournisseur"}</h3>
              <p>
                {query
                  ? "Essayez avec un autre nom, contact ou responsable."
                  : "Ajoutez un premier fournisseur pour constituer votre répertoire."}
              </p>
            </div>
          )}
        </section>

        <SupplierForm
          isModal={this.state.isModal}
          formData={this.state.formData}
          showModal={this.showModal}
        />

        <EstablishmentprofileData
          isModal={this.state.isModalProfile}
          formData={this.state.userestablishprofile}
          fromUser={this.state.user}
          showModal={this.showModalProfile}
        />
      </main>
    );
  }
}

export default Supplier;
